import { ItemsTableMessages } from "@/messages/orders/order-items-table.messages";

export const ITEMS_TABLE_COLUMNS = (messages: ItemsTableMessages) => {
  return [
    messages.skuCodeColumn, // "Código"
    messages.titleColumn, // "Descrição"
    messages.variationColumn, // "Variação"
    messages.quantityColumn, // "Quantidade"
    messages.netUnitPriceColumn, // "Valor Unitário"
    messages.netLineAmountColumn, // "Preço Total"
    messages.userCommentColumn, // "Comentário"
    messages.optionsColumn,
  ];
};
